import { render } from "./CompetitorKeywordsModal.vue?vue&type=template&id=5b03c9e8&scoped=true"
import script from "./CompetitorKeywordsModal.vue?vue&type=script&lang=js"
export * from "./CompetitorKeywordsModal.vue?vue&type=script&lang=js"

import "./CompetitorKeywordsModal.vue?vue&type=style&index=0&id=5b03c9e8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b03c9e8"]])

export default __exports__